import React from 'react';
import { combineClassNames } from '../../../../core/css';
import FallbackCgi from '../../cgi/FallbackCgi';
import CGISpinner from '../../images/cgiSpinner/CGISpinner';
import useImage from '../../images/useImage';
import useCompareMediaQuery, {
  LARGE,
  MEDIUM,
  SMALL,
  XLARGE,
} from '../useCompareMediaQuery';

const CompareHeaderImage = ({ cgi, alt, isScrolled }) => {
  const { hasLoaded, hasError } = useImage(cgi);
  const compareQuery = useCompareMediaQuery();

  const getCurrentLoaderDimensions = () => {
    switch (compareQuery) {
      case SMALL:
        return {
          height: 100,
          width: 133,
        };
      case MEDIUM:
        return {
          height: 140,
          width: 173,
        };
      case LARGE:
      case XLARGE:
        return {
          height: 170,
          width: 203,
        };
    }
  };
  return (
    <div
      className={combineClassNames(
        'header-item__image-container',
        isScrolled ? ' header-item__image--hidden' : '',
        hasError ? 'header-item__image-container--fallback' : ''
      )}>
      {!hasError && (
        <>
          {!hasLoaded && <CGISpinner {...getCurrentLoaderDimensions()} />}
          {hasLoaded && (
            <img className="header-item__image" src={cgi} alt={alt} />
          )}
        </>
      )}
      {hasError && <FallbackCgi hideLabel noPadding transparent />}
    </div>
  );
};

export default CompareHeaderImage;
